import { Routes, RouterModule } from "@angular/router";
import { NgModule } from "@angular/core";
import { LoginComponent } from "./modules/Global_Components/Login/login.component";
import { EmailverifyComponent } from "./modules/Global_Components/emailverify.component";
import { ForgotpasswordComponent } from "./modules/Global_Components/Forget_Password/forgotpassword.component";
import { ResetpasswordComponent } from "./modules/Global_Components/resetpassword.component";
//import { IncidentAcceptVerifyComponent } from './app-components/incidentAccept.component';
//import { EmpComplaintAcceptVerifyComponent } from './app-components/empComplaintAcceptVerify.component';
import { PageNotFoundComponent } from "./pagenotfound.component";
import { VerifyAccountComponent } from "./modules/Global_Components/verifyAccount.component";

const routes: Routes = [
  {
    path: "",
    component: LoginComponent
  },
  {
    path: "user",
    loadChildren: "./modules/Layouts/admin_layout.module#AdminLayoutModule"
  },
  {
    path: "user",
    loadChildren: "./modules/Layouts/admin_layout.module#AdminLayoutModule"
  },
  {
    path: "forgotpassword",
    component: ForgotpasswordComponent
  },
  {
    path: "resetpassword/:id",
    component: ResetpasswordComponent
  },
  {
    path: "verifyAccount/:id",
    component: VerifyAccountComponent
  },
  /*
    {
        path: 'verify_account/:id',
        component: EmailverifyComponent
    },

    {
        path: 'resetpassword/:id',
        component: ResetpasswordComponent
    },
    {
        path: 'visitGoogleRating/:id',
        component: TrackVisitorComponent
    },
    {
        path: 'vlink/:id',
        component: TrackVisitorComponent
    },
    {
        path: 'gmailConfiguration',
        component: GmailRedirectUrlComponent
    },
    {
        path: 'patient-review',
        component: PatientReviewComponent,

    },
    {
        path: 'visitorReview/:id',
        component: VisitorReviewComponent
    },
    {
        path: 'verify_incident_accept_request/:id',
        component: IncidentAcceptVerifyComponent,

    },
    {
        path: 'verify_incident_reject_request/:id',
        component: IncidentRejectVerifyComponent,

    },
    {
        path: 'verify_task_accept_request/:id',
        component: TaskAcceptVerifyComponent,

    },
    {
        path: 'verify_task_reject_request/:id',
        component: TaskRejectVerifyComponent,

    },
    {
        path: 'verifyComplaintAcceptRequest/:id',
        component: EmpComplaintAcceptVerifyComponent,

    },
    {
        path: 'survey/:surveyId/:contactId',
        component: SurveySubmitComponent,

    },
    {
        path: 'privacyPolicy',
        component: PrivacyPolicyComponent
    },
    {
        path: 'company',
        loadChildren: './layout/company/company_layout.module#CompanyLayoutModule'
    },
    {
        path: 'facility',
        loadChildren: './layout/facility/facility_layout.module#FacilityLayoutModule'
    },
    */
  {
    path: "**",
    component: PageNotFoundComponent
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      //enableTracing: true
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
